import { FrameRectangle } from '../../../../../common/components/cart-loader/frame-rectangle/FrameRectangle';
import styles from './AddToListImageLoader.module.scss';

export const AddToListImageLoader = () => (
  <div data-testid="add-to-list-image-loader" className={styles['add-to-list-image-loader']}>
    <FrameRectangle className={styles['add-to-list-image-loader-section-left-box']} />
    <div className={styles['add-to-list-image-loader-section-right']}>
      <FrameRectangle className={styles['add-to-list-image-loader-section-right-box']} />
      <FrameRectangle className={styles['add-to-list-image-loader-section-right-box']} />
      <FrameRectangle className={styles['add-to-list-image-loader-section-right-box']} />
    </div>
  </div>
);
